import { render } from "./index.vue?vue&type=template&id=f8ec1efc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f8ec1efc&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=f8ec1efc&lang=less"
script.render = render
script.__scopeId = "data-v-f8ec1efc"

export default script